import { Button2, type ButtonProps } from "../atoms/Button";
import DownloadIcon from "@/assets/images/icons2/icon--download.svg?component";

export function DownloadButton({ children: _children, ...buttonProps }: ButtonProps) {
  return (
    <Button2 variant="blank" {...buttonProps}>
      <DownloadIcon />
    </Button2>
  );
}
